import { render } from "./PlanCardContent.vue?vue&type=template&id=116d28f8&ts=true"
import script from "./PlanCardContent.vue?vue&type=script&lang=ts"
export * from "./PlanCardContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__